/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./language-list.vue?vue&type=template&id=2e018c2b&scoped=true&"
import script from "./language-list.vue?vue&type=script&lang=js&"
export * from "./language-list.vue?vue&type=script&lang=js&"
import style0 from "./language-list.vue?vue&type=style&index=0&id=2e018c2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e018c2b",
  null
  
)

export default component.exports